export default __webpack_public_path__ + "static/media/natural.9a32ab3b.jpeg";